.root {
  align-items: center;
  background-color: var(--color-muted, #f4f4f5);
  border: 2px dashed var(--color-border, #d4d4d8);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 32px 24px;
  text-align: center;
  transition:
    background-color 120ms ease,
    border-color 120ms ease;
  width: 100%;
}

.root:hover,
.root-is-active {
  background-color: var(--color-accent, #e4e4e7);
  border-color: var(--color-ring, #71717a);
}

.root-is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.icon {
  color: var(--color-muted-foreground, #71717a);
}

.prompt {
  color: var(--color-foreground, #18181b);
  font-size: 14px;
  font-weight: 500;
}

.hint {
  color: var(--color-muted-foreground, #71717a);
  font-size: 12px;
}

.progress {
  background-color: var(--color-border, #d4d4d8);
  border-radius: 4px;
  height: 6px;
  margin-top: 8px;
  overflow: hidden;
  width: 100%;
}

.progress-fill {
  background-color: var(--color-primary, #18181b);
  height: 100%;
  transition: width 120ms ease;
}
